import PropTypes from 'prop-types';

const StepSvg = ({ color, width, height }) => {
  return (
    <svg
      width={`${width || 26}`}
      height={`${height || 25}`}
      viewBox="0 0 26 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="13" cy="12.5" r="6" fill={color} />
      <rect x="1" y="0.5" width="24" height="24" rx="12" stroke={color} />
    </svg>
  );
};

StepSvg.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

export default StepSvg;
